<div class="min-h-screen px-4 sm:px-6 lg:px-8 py-12">
  <div class="container mx-auto">

    <!-- Encabezado -->
    <div class="text-center lg:text-left mb-10">
      <h1 class="text-4xl lg:text-5xl font-bold mb-2 animate-fade-slide-up text-gray-100">
        Historial de Misiones
      </h1>
      <p class="text-gray-400 animate-fade-slide-up" style="animation-delay: 0.2s;">
        Revisa el registro de tus compras pasadas en Eagle Tech.
      </p>
    </div>

    @if (isLoading$ | async) {
      <!-- Estado de Carga -->
      <div class="space-y-8">
        @for (i of [1, 2, 3]; track i) {
          <app-galaxy-card>
            <div galaxy-card-content class="p-5">
              <div class="flex flex-col md:flex-row md:items-center gap-4">
                <div class="flex-grow space-y-2">
                  <app-galaxy-skeleton height="1rem" width="40%"></app-galaxy-skeleton>
                  <app-galaxy-skeleton height="1rem" width="30%"></app-galaxy-skeleton>
                </div>
                <div class="flex items-center gap-4 md:gap-6">
                  <app-galaxy-skeleton height="2rem" width="8rem"></app-galaxy-skeleton>
                  <app-galaxy-skeleton height="2rem" width="8rem"></app-galaxy-skeleton>
                </div>
              </div>
            </div>
          </app-galaxy-card>
        }
      </div>
    } @else {
      <!-- Contenido Principal -->
      @if ((orders$ | async); as orders) {
        @if (orders.length === 0) {
          <!-- Estado Vacío -->
          <app-galaxy-card class="text-center animate-fade-slide-up" padding="lg">
            <div galaxy-card-content>
              <div class="max-w-md mx-auto">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-24 h-24 sm:w-28 sm:h-28 text-violet-400/40 mx-auto mb-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                <h2 class="text-2xl sm:text-3xl font-bold text-gray-100">Sin registros de misiones</h2>
                <p class="text-gray-400 mt-3 mb-8">Tu historial de órdenes está vacío. ¡Una nueva adquisición podría ser tu primera misión registrada!</p>
                <button [routerLink]="['/tienda']" appGalaxyButton appGalaxyRipple class="galaxy-variant-primary galaxy-size-md">
                  Ir a la Tienda
                </button>
              </div>
            </div>
          </app-galaxy-card>
        } @else {
          <!-- Lista de Órdenes -->
          <div class="space-y-8" appAnimateStagger>
            @for (order of orders; track order.id) {
              <app-galaxy-card #staggerItem class="overflow-hidden transition-all duration-300">
                <div galaxy-card-content>
                  <div class="p-5 border-b border-white/10 flex flex-col md:flex-row md:items-center gap-4">
                    <div class="flex-grow space-y-1">
                      <p class="text-sm text-gray-400">Orden <span class="font-bold text-gray-200">#{{ order.id }}</span></p>
                      <p class="text-sm text-gray-300">{{ order.dateCreated | date: 'dd/MM/yyyy, h:mm a' }}</p>
                    </div>
                    <div class="flex items-center gap-4 md:gap-6">
                      <div class="text-left md:text-right">
                        <p class="text-sm text-gray-400">Total</p>
                        <p class="font-bold text-xl text-warm-gold">{{ order.total | currency:'USD' }}</p>
                      </div>
                      <div class="h-10 border-l border-white/10 hidden md:block"></div>
                      <div>
                        <p class="text-sm text-gray-400">Estado</p>
                        <span class="px-3 py-1 text-xs font-semibold rounded-full uppercase tracking-wider block mt-1" [ngClass]="order.orderState.toString() | orderStatusStyle">
                          {{ order.orderState }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="p-5 flex flex-col sm:flex-row gap-5 justify-between items-start">
                    <div class="flex items-center -space-x-4">
                      @for (item of order.orderProducts.slice(0, 5); track item.id) {
                        <img [src]="item.productImageUrl || 'https://placehold.co/100x100/0a040d/a78bfa?text=Eagle'" [alt]="item.productName" class="w-12 h-12 rounded-full object-cover shadow-neumorphic-dark-inset-sm" [title]="item.productName + ' (x' + item.quantity + ')'">
                      }
                      @if (order.orderProducts.length > 5) {
                        <div class="w-12 h-12 rounded-full bg-slate-gray flex items-center justify-center text-sm font-semibold text-warm-gold shadow-neumorphic-dark-inset-sm">
                          +{{ (order.orderProducts).length - 5 }}
                        </div>
                      }
                    </div>
                    <button appGalaxyButton class="galaxy-variant-secondary galaxy-size-sm mt-4 sm:mt-0" [disabled]="true">
                      Ver Detalles
                    </button>
                  </div>
                </div>
              </app-galaxy-card>
            }
            @if ((totalPages$ | async)! > 1) {
              <div class="flex justify-center items-center space-x-3 mt-10">
                <button (click)="goToPreviousPage()" [disabled]="(currentPage$ | async) === 0" appGalaxyButton class="galaxy-variant-secondary !rounded-full !w-12 !h-12 !p-0">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" /></svg>
                </button>
                <div class="font-semibold text-gray-200 bg-white/10 backdrop-blur-md py-2 px-4 rounded-full">
                  Página <span class="text-gray-100">{{ ((currentPage$ | async) || 0) + 1 }}</span> / <span class="text-gray-100">{{ totalPages$ | async }}</span>
                </div>
                <button (click)="goToNextPage()" [disabled]="(currentPage$ | async)! >= ((totalPages$ | async) || 0) - 1" appGalaxyButton class="galaxy-variant-secondary !rounded-full !w-12 !h-12 !p-0">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" /></svg>
                </button>
              </div>
            }
          </div>
        }
      }
    }
  </div>
</div>
